import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store';

/**
 * ProtectedRoute — purely synchronous, zero async, zero loops.
 *
 * Auth state is resolved ONCE at startup in AppRouter before this
 * component ever renders. This component only reads the store.
 */
export const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated || !user) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default ProtectedRoute;
